<template>
  <b-container fluid class="competition-steps">
    <b-row v-if="loading === true" class="competition-col-pd">Loading </b-row>
    <b-row>
      <b-col md="4"
        ><b-form-group id="complex-filter-name" label="Komplex szűrő neve">
          <!-- <label class="complex-filter-label">Komplex szűrő neve</label> -->
          <b-form-input
            id="complex-filter-name"
            placeholder="Nagyvállalat..."
            v-model="name"
            type="text"
            class="border inputFieldAlign"
          >
          </b-form-input>
          <input-error :v-if="errors.name.length > 0" :errors="errors.name" /> </b-form-group
      ></b-col>
    </b-row>
    <b-row
      ><b-col md="4">
        <label class="competition-label dropdown-label">Feltételrendszer meghatározása</label
        ><b-dropdown :text="readableLogic" class="dropdown-competition height40px"
          ><b-dropdown-item @click="onChangeLogic(logicOperators.OR)" :value="logicOperators.OR"
            >Legalább egy feltételnek teljesülnie kell</b-dropdown-item
          >
          <b-dropdown-item @click="onChangeLogic(logicOperators.AND)" :value="logicOperators.AND"
            >Minden feltételnek teljesülnie kell</b-dropdown-item
          >
        </b-dropdown>
      </b-col>
      <b-col md="4" class="relative">
        <b-button variant="primary" @click="addBlock" class="width100  absolute bottom0 left0 height50">
          Új feltétel hozzáadása
        </b-button>
      </b-col>
    </b-row>
    <b-row v-for="(block, blockIndex) in conditions" :key="`filter-block=${blockIndex}`" class="block-container">
      <b-col md="12">
        <b-row class="block-header">
          <b-col md="2" class="block-title">{{ blockIndex + 1 }}. Feltétel</b-col>
          <b-col md="2">
            <div @click="deleteBlock(blockIndex)" class="delete-button-complex-filter">
              <delete-field />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <b-dropdown text="Válasszon a feltételek közül" class="dropdown-competition height40px">
              <b-dropdown-item
                v-for="(filter, index) in getAvailableFilters(block)"
                :key="`${filter.field}-${index}`"
                @click="addFilter(filter, blockIndex)"
              >
                {{ filter.fieldForm.title }}
              </b-dropdown-item>
            </b-dropdown>
            <input-error v-if="getBlockError(blockIndex)" :errors="getBlockError(blockIndex)" />
          </b-col>
          <b-col md="12">
            <company-fields
              :collapseId="blockIndex"
              :getFieldFormErrors="params => getFieldFormErrors(params, blockIndex)"
              :fields="block"
              :onDelete="true"
              :onChanged="blockConditions => onChanged(blockConditions, blockIndex)"
          /></b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-button @click="save" :disabled="conditions.length === 0">Mentés</b-button>
    </b-row>
  </b-container>
</template>
<script>
import { getCompanyFieldFormTemplates } from '../../api/company'
import CompanyFields from '../Competitions/components/CompanyFieldComponents/CompanyFields.vue'
import { LOGIC_OPERATOR } from '../Competitions/models/logicOperator'
import { postComplexFilter, getComplexFilter, patchComplexFilter } from '../../api/complexFilter'
import {
  convertFieldForms,
  convertNumberServerResponse,
  convertArrayServerResponse,
  convertBooleanServerResponse,
  convertAnnualDataServerResponse,
  convertFinanceDataServerResponse
} from '../../converters/fieldFormConverter'
import { COMPETITION_FIELD_TYPE, COMPETITION_SPECIAL_FILTER } from '../Competitions/models/competitionFieldType'
import InputError from '../../components/InputError.vue'
import _ from 'lodash'
import DeleteField from '../Competitions/components/CompanyFieldComponents/DeleteField.vue'
export default {
  name: 'CreateComplexFilter',
  components: { CompanyFields, InputError, DeleteField },
  computed: {
    isEdit: function() {
      return this.$route.query.id !== undefined
    },
    readableLogic: function() {
      if (this.logic === LOGIC_OPERATOR.AND) {
        return 'Minden feltételnek teljesülnie kell'
      } else {
        return 'Legalább egy feltételnek teljesülnie kell'
      }
    }
  },
  created: async function() {
    const result = await getCompanyFieldFormTemplates()
    let fieldForms = {}
    result.forEach(fieldForm => {
      fieldForms[fieldForm.field] = {
        fieldForm,
        conditions: null
      }
    })
    this.fieldForms = fieldForms
    if (this.isEdit) {
      const complexFilter = await getComplexFilter(this.$route.query.id)
      this.convertServerResponse(complexFilter)
    }
    this.errors = { name: [], requirementFilters: [], blockErrors: [] }
    this.loading = false
  },
  data: function() {
    return {
      fieldForms: [],
      loading: true,
      errors: { name: [], requirementFilters: [], blockErrors: [] },
      name: '',
      logic: LOGIC_OPERATOR.AND,
      conditions: [],
      logicOperators: LOGIC_OPERATOR
    }
  },
  watch: {
    name: function() {
      this.errors.name = []
    }
  },
  methods: {
    addFilter: function(filter, blockIndex) {
      const newConditions = [...this.conditions]
      newConditions[blockIndex][filter.fieldForm.field] = { ...filter, conditions: [] }
      this.conditions = newConditions
    },
    getAvailableFilters: function(filter) {
      return Object.keys(filter)
        .map(key => filter[key])
        .filter(filter => filter.conditions === null)
    },
    addBlock: function() {
      const newConditions = [...this.conditions, { ...JSON.parse(JSON.stringify(this.fieldForms)) }]
      this.conditions = newConditions
    },
    onChanged: function(block, blockIndex) {
      const errorIndex = _.findIndex(this.errors.requirementFilters, rf => rf.field === block.fieldForm.field)
      this.errors.requirementFilters[errorIndex] = []
      const newConditions = JSON.parse(JSON.stringify(this.conditions))
      newConditions[blockIndex][block.fieldForm.field] = block
      this.conditions = newConditions
    },
    getFieldFormErrors: function(params, blockIndex) {
      const fieldFormErrors = []
      this.errors.requirementFilters.forEach(rf => {
        if (rf.blockIndex === blockIndex && rf.index === params.index) {
          fieldFormErrors.push(rf.message)
        }
      })
      if (fieldFormErrors.length === 0) {
        return []
      } else {
        return fieldFormErrors
      }
    },
    deleteBlock: function(blockIndex) {
      const newConditions = JSON.parse(JSON.stringify(this.conditions))
      newConditions.splice(blockIndex, 1)
      this.conditions = newConditions
    },
    getBlockError: function(blockIndex) {
      const blockErrors = []
      this.errors.blockErrors.forEach(be => {
        if (be.blockIndex === blockIndex) {
          blockErrors.push(be.message)
        }
      })
      if (blockErrors.length > 0) {
        return blockErrors
      } else {
        return null
      }
    },
    clearErrors: function() {
      this.errors = { name: [], requirementFilters: [], blockErrors: [] }
    },
    convertServerResponse: function(complexFilter) {
      this.name = complexFilter.name
      const result = []
      complexFilter.requirementFilters.conditions.forEach(block => {
        let blockConditionsResult = {}
        Object.keys(block).forEach(key => {
          const currentFieldForm = this.fieldForms[key].fieldForm
          let currentConditions = {}
          const responseConditions = block[key].conditions
          if (COMPETITION_SPECIAL_FILTER.SPECIAL_FINANCE_DATA_FIELDS.includes(currentFieldForm.field)) {
            currentConditions = convertFinanceDataServerResponse(responseConditions)
            blockConditionsResult = {
              ...blockConditionsResult,
              [key]: { conditions: currentConditions, fieldForm: this.fieldForms[key].fieldForm }
            }
          } else if (COMPETITION_SPECIAL_FILTER.SPECIAL_ANNUAL_DATA_FIELDS.includes(currentFieldForm.field)) {
            currentConditions = convertAnnualDataServerResponse(responseConditions)
            blockConditionsResult = {
              ...blockConditionsResult,
              [key]: { conditions: currentConditions, fieldForm: this.fieldForms[key].fieldForm }
            }
          } else {
            switch (currentFieldForm.type.mainType) {
              case COMPETITION_FIELD_TYPE.NUMBER: {
                currentConditions = convertNumberServerResponse(responseConditions, currentFieldForm)
                blockConditionsResult = {
                  ...blockConditionsResult,
                  [key]: { conditions: currentConditions, fieldForm: this.fieldForms[key].fieldForm }
                }
                break
              }
              case COMPETITION_FIELD_TYPE.ARRAY: {
                currentConditions = convertArrayServerResponse(responseConditions)
                blockConditionsResult = {
                  ...blockConditionsResult,
                  [key]: { conditions: currentConditions, fieldForm: this.fieldForms[key].fieldForm }
                }
                break
              }
              case COMPETITION_FIELD_TYPE.BOOLEAN: {
                currentConditions = convertBooleanServerResponse(responseConditions)
                blockConditionsResult = {
                  ...blockConditionsResult,
                  [key]: { conditions: currentConditions, fieldForm: this.fieldForms[key].fieldForm }
                }
                break
              }
            }
          }
        })
        const blockResult = { ...this.fieldForms, ...blockConditionsResult }
        result.push(blockResult)
      })
      this.logic = complexFilter.requirementFilters.logic
      this.conditions = result
    },
    onChangeLogic: function(logic) {
      this.logic = logic
    },
    save: async function() {
      try {
        if (this.isEdit) {
          await patchComplexFilter(
            {
              name: this.name,
              requirementFilters: { logic: this.logic, conditions: this.conditions.map(v => convertFieldForms(v)[0]) }
            },
            this.$route.query.id
          )
          this.$store.dispatch('notify', {
            newNotification: { type: 'success', message: 'Szűrő sikeresen módosítva' }
          })
        } else {
          await postComplexFilter({
            name: this.name,
            requirementFilters: { logic: this.logic, conditions: this.conditions.map(v => convertFieldForms(v)[0]) }
          })
          this.$store.dispatch('notify', {
            newNotification: { type: 'success', message: 'Szűrő sikeresen létrehozva' }
          })
        }
        this.$router.push('/competitions/complex-filter')
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.errors.name = ['Ez a név már szerepel a rendszerben', ...this.errors.name]
        }
        if (error.response && error.response.status === 400) {
          this.clearErrors()
          const errorData = error.response.data
          const errors = { ...this.errors }
          const requirementErrors = [...this.errors.requirementFilters]
          const blockErrors = [...this.errors.blockErrors]
          Object.keys(this.conditions).forEach(key => {
            requirementErrors[key] = []
          })
          errorData.details.forEach(e => {
            if (e.path.length === 3) {
              blockErrors.push({ blockIndex: e.path[1], message: e.message })
            } else if (e.path.length === 8) {
              requirementErrors.push({ index: e.path[5], blockIndex: e.path[2], message: e.message, field: e.path[3] })
            } else {
              errors[e.context.key] = [e.message]
            }
          })
          this.errors = { ...errors, requirementFilters: requirementErrors, blockErrors }
        } else {
          throw error
        }
      }
    }
  }
}
</script>
<style scoped>
.row {
  margin-top: 15px;
  margin-bottom: 15px;
}

.complex-filter-label {
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: #636e72;
  padding-left: 10px;
}

.create-complex-filter legend {
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: #636e72;
  padding-left: 10px;
}

.block-container {
  position: relative;
}
.delete-button-complex-filter {
  /* position: absolute; */
  /* top: 10px; */
  /* right: 10px; */
  color: red;
  z-index: 5;
}
.delete-button-complex-filter:hover {
  cursor: pointer;
  color: #b30000;
}

.block-card {
  width: 100em;
  padding-top: 45px;
}

.block-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: black;
}
.width100 {
  width: 100%;
}
.dropdown-label {
  float: left;
}
.absolute {
  position: absolute;
}
.bottom0 {
  bottom: 0;
}
.relative {
  position: relative;
}
.left0 {
  left: 0;
}
.height50 {
  height: 48px;
}
</style>
